import { Component, inject } from '@angular/core';
import { WoodProductDetailService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  WoodProductDetailCreateDto,
  WoodProductDetailDto,
  WoodProductDetailExcelDownloadDto,
  WoodProductDetailUpdateDto,
} from '../proxy/general/dtos/wood-product-detail';
import { WOODPRODUCTDETAIL_CONFIG, WOODPRODUCTDETAIL_FIELDS } from './wood-product-detail.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-wood-product-detail',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, WoodProductDetailService, ConfirmationService],
  templateUrl: './wood-product-detail.html',
  styleUrl: './wood-product-detail.scss',
})
export class WoodProductDetail extends BaseHierarchicalCrudComponent<
  WoodProductDetailDto,
  WoodProductDetailCreateDto,
  WoodProductDetailUpdateDto,
  WoodProductDetailExcelDownloadDto
> {
  service = inject(WoodProductDetailService);
  config = WOODPRODUCTDETAIL_CONFIG;
  fields = WOODPRODUCTDETAIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: WoodProductDetailDto): WoodProductDetailUpdateDto {
    return {
      isFscCertified: data.isFscCertified,
      isWoodLog: data.isWoodLog,
      bdmtMcsFactor: data.bdmtMcsFactor,
      isPefcCertified: data.isPefcCertified,
      finalProductId: data.finalProductId,
      speciesId: data.speciesId,
      lengthId: data.lengthId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'WoodProductDetail';
  }
}
